import { isIos } from "@/utils/lodash";
import Http from "@/api/http/fetch/index";

export let androidStatusBarHeight = "padding-top:20px;";

export const initialStatusBarHeight = () => {
  try {
    Http.GetStatusBarHeight().then((result: any) => {
      const statusBarHeight = parseInt(result);
      androidStatusBarHeight = `padding-top:${statusBarHeight}px`;
    });
  } catch (error) {}
};

// const androidStatusBarHeight = {
//   paddingTop: "android-padding-top",
//   fixedTop: "android-fixed-top"
// };

if (isIos()) {
  // androidStatusBarHeight.paddingTop = "ios-padding-top";
  // androidStatusBarHeight.fixedTop = "ios-fixed-top";
  androidStatusBarHeight = "";
}
